import throttle from 'lodash.throttle'

interface ThrottleSettings {
  target?: HTMLElement,
  callback: (e?: {
    prevScrollPos?: number,
    updateScrollPos?: number,
    isUp?: boolean,
    isDown?: boolean,
    isPageLoad?: boolean,
  }) => void,
  wait: number,
}

export default {
  /**
   * 要素のスクロール位置を取得
   *
   * @description
   *  引数に対象エレメントを指定した場合は、対象エレメントの Y 座標を取得
   *  引数の指定がない場合は、ウィンドウのスクロール位置を取得
   * @returns { number }
   */
  getScrollY(target?: HTMLElement | undefined): number {
    return target
      ? target.scrollTop
      : window.scrollY !== undefined
        ? window.scrollY
        : (
          document.documentElement ||
          document.body.parentNode ||
          document.body
        ).scrollTop
  },
  /**
   * 遅延付スクロールイベント
   * @description ネイティブのスクロールイベントで処理を発火させると負荷が高いため、lodash の throttle で遅延発火させる。
   */
  throttle($: ThrottleSettings): () => void {
    let currentScrollPos: number = 0
    let prevScrollPos: number | null = null

    // document load 時に走ってしまう scroll イベントかどうか
    let isPageLoad = false

    const listener = () => {
      const updateScrollPos = this.getScrollY($.target)

      // 変化量が少なかったら何もしない(ガタガタするのを防止する)
      if (Math.abs(currentScrollPos - updateScrollPos) <= 3) return

      // 上下スクロール方向の判定
      const isUp = currentScrollPos ? currentScrollPos > updateScrollPos : false
      const isDown = currentScrollPos ? currentScrollPos < updateScrollPos : false

      // 現在スクロール位置の更新
      isPageLoad = (prevScrollPos === null)
      prevScrollPos = currentScrollPos
      currentScrollPos = updateScrollPos

      // 個別の処理を実行
      $.callback.call(null, { prevScrollPos, updateScrollPos, isUp, isDown, isPageLoad })
    }

    const throttled = throttle(listener, $.wait)
    const scrollTarget = $.target || window

    scrollTarget.addEventListener('scroll', throttled)

    const loadListener = () => {
      // 初期スクロール位置の取得
      currentScrollPos = this.getScrollY()
    }
    window.addEventListener('load', loadListener)

    return () => {
      throttled.cancel()
      scrollTarget.removeEventListener('scroll', throttled)
      window.removeEventListener('load', loadListener)
    }
  },
}
